import React from 'react';
import DetailsBox from '../common/DetailsBox/DetailsBox';
import ListView from '../common/ListView/ListView';

const CountryDvpnnodesList = () => {
    return (
        <DetailsBox
            subtitle="US - All Nodes"
            subtitlelink="countries"
            >
                <div className="listing-main-wrapper">
                    <ListView
                        countryflagname="US"
                        nodename="Obedient Blood Mule"
                        speed="200"
                        url="dvpnnodes-details"
                    />
                    <ListView
                        countryflagname="US"
                        nodename="Soft Orange Boar"
                        speed="180"
                        url="dvpnnodes-details"
                    />
                    <ListView
                        countryflagname="US"
                        nodename="Ripe Peach Python"
                        speed="175"
                        url="dvpnnodes-details"
                    />
                    <ListView
                        countryflagname="US"
                        nodename="Magic Neon Wolf"
                        speed="160"
                        url="dvpnnodes-details"
                    />
                    <ListView
                        countryflagname="US"
                        nodename="Exotic Topaz Tapir"
                        speed="160"
                        url="dvpnnodes-details"
                    />
                    <ListView
                        countryflagname="US"
                        nodename="Dizzy Midnight Pheasant"
                        speed="155"
                        url="dvpnnodes-details"
                    />
                    <ListView
                        countryflagname="US"
                        nodename="Blurry Lemonade Kangaroo"
                        speed="120"
                        url="dvpnnodes-details"
                    />
                    <ListView
                        countryflagname="US"
                        nodename="Tall Tartan Kestrel"
                        speed="100"
                        url="dvpnnodes-details"
                    />
                </div>
        </DetailsBox>
    )
}

export default CountryDvpnnodesList
